import * as types from '../actions/types';

export default (state = 10, { type, payload }) => {
    switch (type) {
        case types.UPDATE_FRACTIONS:
            const nextState = state + payload.pas;
            if (nextState < 1 || nextState > 20) return state;
            return state + payload.pas;
        default:
            return state;
    }
};
